module.exports = __webpack_public_path__ + "img/icon-legislated-events.09053b4a.svg";